import { call, put, takeLatest } from "@redux-saga/core/effects";
import { getListAccount } from "@iso/services/admin";
import { notification } from "@iso/components";
import actions from "./actions";
function* fetchListAdmin() {
  yield put({ type: actions.SET_IS_LOADING, payload: true });
  const { result, errCode, errDetail } = yield call(getListAccount);
  if (errCode) {
    return notification("error", errDetail);
  }
  yield put({ type: actions.SET_LIST_ADMIN, payload: result.data });
}

export default function* rootSaga() {
  yield takeLatest(actions.GET_LIST_ADMIN, fetchListAdmin);
}
